<template>
  <!-- Stand-in for imagery until real product photos are hooked up. -->
  <div class="placeholder-art" :class="`placeholder-art--${tone % 4}`" role="img" :aria-label="label || 'Image coming soon'">
    <div class="placeholder-art__mat">
      <span v-if="label" class="placeholder-art__label">{{ label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaceholderArt',

  props: {
    label: { type: String, default: '' },
    tone: { type: Number, default: 0 },
  },
}
</script>

<style scoped>
.placeholder-art {
  width: 100%;
  height: 100%;
  padding: 8%;
  background: var(--paper);
}

.placeholder-art--1 { background: var(--blush); }
.placeholder-art--2 { background: var(--sky); }
.placeholder-art--3 { background: var(--linen); }

.placeholder-art__mat {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(43, 36, 32, 0.14);
  background: rgba(248, 243, 234, 0.45);
}

.placeholder-art__label {
  font-family: var(--font-display);
  font-style: italic;
  font-size: 1.8rem;
  color: var(--stone);
  text-align: center;
  padding: 0 1rem;
}
</style>
